import PackageEdit from "../Edits/PackageEdit";
import CmModal from "../Controls/CmModal";

export default function PackageEditModal({
  packageId = 0,
  employerId = 0,
  onClose,
}) {
  const id = Number.parseInt(packageId, 10) || 0;
  const empId = Number.parseInt(employerId, 10) || 0;
  const title = id > 0 ? "Package" : "Add Package";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="package-edit-modal"
    >
      <PackageEdit packageId={id} employerId={empId} onClose={onClose} />
    </CmModal>
  );
}
